<template>
	<div id="linkChurchWithGenesysModalComponent">
		<button class="btn-link" data-toggle="modal" data-target=".legal-document-modal-component" @click="showChurchLocal" ref="btnShowLinkChurchWithGenesysModalComponent" v-show="false">Abrir Modal Vinculación</button>

		<div class="modal fade legal-document-modal-component" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Vincular Cliente de Genesys</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<p>
							<label>
								{{ objectChurch.type_church.name }} {{ objectChurch.name }}
							</label>
							<span class="float-right">
								ID: {{ objectChurch.id }}
							</span>
						</p>
						<p>
							Distrito: {{ objectChurch.district.name}}
							- Campo: {{ objectChurch.entity.name}}
						</p>
						<nav class="navbar navbar-light bg-light">
							<div class="form-inline">
								<input class="form-control form-control-sm mr-sm-1" type="text" placeholder="Buscar" aria-label="Buscar" ref="searchChurchGenesys"
									v-model="searchChurchGenesysLocal"
									v-on:keyup.enter="getAllChurchsGenesysLocal()"
									@focus="$event.target.select()">
								<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllChurchsGenesysLocal" :disabled="(searchChurchGenesysLocal.length < 3)">Buscar</button>
								<div class="float-right d-none d-sm-inline separator"></div>
							</div>
						</nav>

						<table class="table table-sm table-12">
							<thead>
								<tr>
									<th class="text-center">Código</th>
									<th class="text-center">Nombre</th>
									<th class="text-center">Campo</th>
									<th class="text-center"><i class="fas fa-link"></i></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listChurchsGenesys" :key="index" :class="(objectChurch.genesys != null && objectChurch.genesys.clicod == item.clicod) ? 'font-weight-bold' : ''">
									<td class="text-center">{{item.clicod}}</td>
									<td>{{item.cliape + ' ' + item.clinom}}</td>
									<td class="text-center">{{item.sintetico_campo}}</td>
									<td class="text-center">
										<i class="far fa-circle text-secundary pointer" v-if="(objectChurch.genesys == null) || (objectChurch.genesys != null && objectChurch.genesys.clicod != item.clicod)" title="Vincular" @click="saveChurchGenesys(objectChurch.id, item.clicod)"></i>
										<i class="far fa-check-circle text-primary" v-else title="Vinculado"></i>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import church from '@/mixins/generals/church.js'

	export default {
		name: 'linkChurchWithGenesysModalComponent',
		mixins: [axiosAction, errors, mixin, church],
		props: ['churchId'],
		data () {
			return {
				id: this.churchId,
				searchChurchGenesysLocal: ''
			}
		},
		computed: {
		},
		methods: {
			getAllChurchsGenesysLocal() {
				if(this.searchChurchGenesysLocal.length > 2) {
					this.getAllChurchsGenesys(this.searchChurchGenesysLocal)
				}
			},
			getAllChurchsGenesysResultLocal(response) {
			},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'showChurchResult': this.showChurchResult(response); break;
					case 'getAllChurchsGenesysResult': this.getAllChurchsGenesysResult(response); break;
					case 'saveChurchGenesysResult': this.saveChurchGenesysResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			showChurchLocal() {
				this.searchChurchGenesysLocal = ''
				this.listChurchsGenesys = []
				this.showChurch(this.id)
			},
			showChurchResultLocal(response) {
				if(this.objectChurch.genesys != null) {
					this.searchChurchGenesysLocal = this.objectChurch.name
					this.getAllChurchsGenesysLocal()
				}
			},
			saveChurchGenesysResultLocal(response) {
				if(response.data.success == true) {
					this.objectChurch.genesys = response.data.data
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
